













































































































import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../common/user-avatar.vue";
import InviteModal from "./invite-modal.vue";
import { on } from "iview/src/utils/dom";
import Util from "./../../lib/util";

import Modal from "../common/confirm.js";

export default Vue.extend({
  name: "UserList",
  components: { UserAvatar, InviteModal },
  data() {
    let context = this as any;
    return {
      mediaMatched: null,
      userRole: 0,
      showInvite: false,
      settingCount: 0,
      showColumnSetup: false,
      dynamicColumnSettings: ["memberName", "emailAddress", "role"],
      dynamicColumns: [
        {
          title: "USER NAME",
          key: "memberName",
          slot: "name",
          minWidth: 200,
          sortable: true,
        },
        {
          title: "EMAIL",
          key: "emailAddress",
          slot: "emailAddress",
          sortable: true,
          minWidth: 200,
        },
        {
          title: "PHONE",
          key: "phoneNumber",
          slot: "phoneNumber",
          sortable: true,
          minWidth: 120,
        },
        {
          title: "PERMISSION",
          key: "role",
          slot: "permission",
          minWidth: 180,
          sortable: true,
          filters: [
            {
              label: "Account Owner",
              value: 1,
            },
            {
              label: "Manager",
              value: 2,
            },
            {
              label: "User",
              value: 3,
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.role === value;
          },
        },
        {
          title: "GOALS",
          key: "joinedGoalCount",
          slot: "goals",
          sortable: true,
          minWidth: 100,
        },
        {
          title: "PROJECTS",
          key: "joinedProjectCount",
          slot: "projects",
          sortable: true,
          minWidth: 120,
        },
        {
          title: "LAST ACTIVE",
          slot: "last-active",
          sortable: true,
          minWidth: 180,
        },
      ],
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount"]),
    ...mapGetters("billing", ["inviteMessage"]),
    columns() {
      let context = this;
      context.settingCount; // force recomputing

      let result: Array<any> = new Array();
      let settings = context.dynamicColumnSettings;
      let firstColumn = context.getDynamicColumn(settings[0]);
      firstColumn.align = "left";
      result.push(firstColumn);

      if (context.mediaMatched === false) {
        result.push(context.getDynamicColumn(settings[1]));
        result.push(context.getDynamicColumn(settings[2]));
      }
      result = result.concat([
        {
          title: "STATUS",
          slot: "status",
          width: 120,
          align: "center",
          sortable: true,
          filters: [
            {
              label: "Active",
              value: "active",
            },
            {
              label: "Unlicensed",
              value: "unlicensed",
            },
            {
              label: "Pending",
              value: "pending",
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return context.getUserStatus(row) === value;
          },
        },
        {
          title: "EDIT",
          key: "memberId",
          slot: "edit",
          width: 80,
          align: "center",
        },
      ]);

      return result;
    },
    assignedQuantity() {
      let context = this as any;
      return context.billingAccount.members.filter((m) => m.licenseAssigned === true).length;
    },
    notAssignedQuantity() {
      let context = this as any;
      return context.billingAccount.licenseQuantity - context.assignedQuantity;
    },
    users() {
      let context = this as any;
      return context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => (context.userRole === 0 ? true : m.role === context.userRole)) : [];
    },
  },
  watch: {},
  mounted() {
    let abp = Util.abp;
    this.dynamicColumnSettings = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyUserListColumns"]) : ["memberName", "emailAddress", "role"];

    on(window, "resize", this.onWindowResize);
    this.matchMedia();
  },
  methods: {
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }

      this.mediaMatched = matchMedia("(max-width: 992px)").matches;
    },
    onWindowResize() {
      this.matchMedia();
    },
    getDynamicColumn(key) {
      let columns = this.dynamicColumns.filter((column) => {
        return column.key == key;
      });

      if (columns.length == 1) {
        return Object.assign(columns[0], { renderHeader: this.renderHeader, align: "left" });
      } else {
        return null;
      }
    },
    renderHeader(h, params) {
      let context = this as any;
      return h("span", {}, [
        h("span", params.column.title),
        h(
          "Poptip",
          {
            props: {
              value: context.showColumnSetup,
              placement: "bottom",
              transfer: true,
              width: "196px",
              trigger: "click",
              offset: 3,
              "popper-class": "ivu-table-popper",
            },
            style: {
              "font-weight": "400",
            },
            ref: "ColumnSetup",
            refInFor: true,
          },
          [
            h("Icon", {
              props: {
                type: "md-settings",
                color: "#B9BCCD",
                size: "12",
              },
              style: {
                "margin-left": "4px",
              },
            }),
            h(
              "div",
              {
                slot: "content",
                class: "", // 调整datepicker样式
              },
              [
                h(
                  "CellGroup",
                  {
                    on: {
                      "on-click": function (name) {
                        let components = context.$refs.UserTable.$children.filter((child) => child.$refs.ColumnSetup);
                        if (components.length == 1) {
                          components[0].$refs.ColumnSetup.forEach((poptip) => {
                            if (poptip.visible === true) {
                              poptip.handleClose();
                            }
                          });
                        }

                        let index = context.dynamicColumnSettings.indexOf(params.column.key);
                        context.dynamicColumnSettings[index] = name;
                        context.showColumnSetup = false;
                        context.settingCount++;

                        context.changeMyUserListColumns();
                      },
                    },
                  },
                  [
                    context.dynamicColumns.map((column) => {
                      return h("Cell", {
                        props: {
                          title: column.title,
                          name: column.key,
                          selected: column.key == params.column.key,
                          disabled: column.key !== params.column.key && context.dynamicColumnSettings.indexOf(column.key) >= 0,
                        },
                        style: {
                          "text-left": "left",
                        },
                      });
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]);
    },
    getUserStatus(user) {
      if (!user.licenseAssigned) {
        return "unlicensed";
      } else {
        return user.accepted ? "active" : "pending";
      }
    },
    getUserStatusStyle(user) {
      if (!user.licenseAssigned) {
        return "error";
      } else {
        return user.accepted ? "success" : "warning";
      }
    },
    getUserStatusText(user) {
      if (!user.licenseAssigned) {
        return "Unlicensed";
      } else {
        return user.accepted ? "Active" : "Pending";
      }
    },
    isOwner(user) {
      let context = this as any;
      return context.billingAccount && user && user.role === 1 && context.billingAccount.originalOwnerId === user.memberId;
    },
    getUserRoleText(user) {
      switch (user.role) {
        case 1:
          return this.isOwner(user) ? "Primary Account Owner" : "Account Owner";
        case 2:
          return "Manager";
        case 3:
          return "User";
        default:
          return "User";
      }
    },
    getDateText(date) {
      return date ? moment(date).format("MMM D, YYYY hh:mm a") : "";
    },
    handleMenuItemClick(name, user) {
      switch (name) {
        case "sendLoginLink":
          this.sendLoginLink(user);
          break;
        case "resendInvite":
          this.reinviteUser(user);
          break;
        case "setPermission":
          this.handleEdit(user);
          break;
        case "archive":
          this.archiveUser(user);
          break;
        case "unarchive":
          this.unarchiveUser(user);
          break;
        case "delete":
          break;
      }
    },
    archiveUser(user) {
      if (user.licenseAssigned === true) {
        Modal.confirm({
          title: "Remove user license?",
          content:
            "<p>When you remove a user's license...</p><ul style='margin-left: 24px;'><li>The user cannot access this GOATSUCCESS account</li><li>The user's history will remain in this GOATSUCCESS account</li><li>The license will be available to assign to a different user</li></ul>",
          okText: "Remove user license",
          cancelText: "Never mind",
          onOk: () => {
            this.$store.dispatch("billing/removeLicense", { data: { memberId: user.memberId } }).then(() => {
              this.$Notice.success({
                title: "Remove user license",
                desc: "Success! ",
              });
            });
          },
        });
      }
    },
    unarchiveUser(user) {
      if (!user.licenseAssigned) {
        this.$store.dispatch("billing/assignLicense", { data: { memberId: user.memberId } }).then(() => {
          this.$Notice.success({
            title: "Restore License",
            desc: "Success! ",
          });
        });
      }
    },
    handleEdit(member) {
      this.$router.push({
        name: "user",
        params: { id: member.memberId.toString() },
        query: { tab: "profile" },
      });
    },
    sendLoginLink(user) {
      this.$store
        .dispatch("billing/sendLoginUrl", {
          data: {
            memberId: user.memberId,
          },
        })
        .then((response) => {
          this.$Notice.success({
            title: "Send login Link",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
    handleInviteClick() {
      this.showInvite = true;
    },
    reinviteUser(user) {
      this.$store
        .dispatch("billing/inviteMember", {
          data: {
            memberId: user.memberId,
            email: user.memberEmailAddress,
            role: user.role,
            message: (this as any).inviteMessage,
            isReinvite: true,
            billingAccountId: user.billingAccountId,
          },
        })
        .then((response) => {
          this.$Notice.success({
            title: "Re-Invite",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
    changeMyUserListColumns() {
      this.$store.dispatch("billing/changeMyUserListColumns", { model: JSON.stringify(this.dynamicColumnSettings) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyUserListColumns"] = JSON.stringify(this.dynamicColumnSettings);
        }
      });
    },
  },
});
